(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/components/nova/tab-links.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/components/nova/tab-links.js');
'use strict';

const TabLinks = _ref => {
  let children = _ref.children,
    stretchItems = _ref.stretchItems;
  return React.createElement("nav", {
    "aria-label": "Fliknavigering",
    className: "qa-ticket-tab-links ticket-tab-links u-flex u-flex-align-items-center ".concat(stretchItems ? ' ticket-tab-links--stretch' : '')
  }, children);
};
setGlobal('svs.tickets.next.components.nova.TabLinks', TabLinks);

 })(window);